(function ($) {
    $('.js-scroll-to').on('click', function (e) {
        e.preventDefault();

        let anchorText = $(this).data('anchor');
        if (!anchorText) return;

        let lowerAnchorText = anchorText.trim().toLowerCase();

        let $target = $('h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6, .casinos-heading').filter(function () {
            return $(this).text().trim().toLowerCase() === lowerAnchorText && !$(this).hasClass('linking-cards__text');
        }).first();

        if ($target.length) {
            let headerHeight = $('header').outerHeight() || 0;
            let targetOffset = $target.offset().top - headerHeight - 10;

            $('html, body').animate({scrollTop: targetOffset}, 400);
        }
    });
})(jQuery);
